module.exports = __webpack_public_path__ + "img/MapButton.1ca2ad54.png";